import { TtPaginator } from './TtPaginator.js';

if (typeof window !== 'undefined') {
  if (!window.customElements.get('tt-paginator')) {
    window.customElements.define('tt-paginator', TtPaginator);
  }
}

export { TtPaginator };
